import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { gsap } from 'gsap';

@Component({
  selector: 'app-figma-benin-hero',
  templateUrl: './figma-benin-hero.component.html',
  styleUrls: ['./figma-benin-hero.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FigmaBeninHeroComponent implements AfterViewInit, OnDestroy {
  @Input() logo = '';
  @Input() heroImage = '';
  @Input() introBackground = '';

  @ViewChild('heroScene') heroScene!: ElementRef<HTMLElement>;

  private ctx?: gsap.Context;

  ngAfterViewInit(): void {
    this.ctx = gsap.context(() => {
      const motionMedia = gsap.matchMedia();

      motionMedia.add('(prefers-reduced-motion: no-preference)', () => {
        gsap.from('.benin-hero__text-layer p', {
          y: 40,
          opacity: 0,
          duration: 1.2,
          ease: 'power3.out',
          delay: 0.2
        });
      });
    }, this.heroScene.nativeElement);
  }

  ngOnDestroy(): void {
    this.ctx?.revert();
  }
}
